import React from 'react';
import AnimatedLogo from './AnimatedLogo';
import styles from './LogoExample.module.css';

const LogoExample = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Animirani Logo Primeri</h1>
      
      <div className={styles.section}>
        <h3>Mali logo bez teksta</h3>
        <AnimatedLogo size="small" showText={false} />
      </div>
      
      <div className={styles.section}>
        <h3>Srednji logo sa tekstom (default)</h3>
        <AnimatedLogo />
      </div>
      
      <div className={styles.section}>
        <h3>Veliki logo sa tekstom</h3>
        <AnimatedLogo size="large" showText={true} />
      </div>
      
      <div className={styles.darkSection}>
        <h3>Logo na tamnoj pozadini</h3>
        <AnimatedLogo size="medium" showText={true} />
      </div>
    </div>
  );
};

export default LogoExample; 